import script from "./SkillPclanguageConfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillPclanguageConfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./SkillPclanguageConfirmView.vue?vue&type=style&index=0&id=5a6da328&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6da328"]])

export default __exports__